var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-d-player',{ref:"player",attrs:{"options":_vm.options},on:{"play":_vm.play}})}
var staticRenderFns = []

export { render, staticRenderFns }